// A file in the upload queue, as a row of a file list: its name, its size, where it stands, and
// a way to take it out while it is not on its way. `children` sits before that control: what a
// deal file is, asked while it waits (documents/PendingTypedFile.jsx).

import { STATES, formatBytes } from '../../deliveries/attachments/uploads.js';
import Icon from '../../ui/Icon.jsx';
import { stateLabel } from './uploadApi.js';

export default function PendingFile({ item, onRemove, waiting, children }) {
  return (
    <li className={`pending ${item.state}`}>
      <span className="attachment-name">
        <strong>{item.file.name}</strong>
        <small>
          {formatBytes(item.file.size)} · {stateLabel(item.state, waiting)}
          {item.error && <span className="error"> — {item.error}</span>}
        </small>
      </span>
      {children}
      {onRemove && item.state !== STATES.uploading && (
        <button type="button" className="icon-button quiet"
                onClick={() => onRemove(item.key)}
                aria-label={`Remove ${item.file.name}`} title="Remove">
          <Icon name="close" />
        </button>
      )}
    </li>
  );
}
